import React from 'react';

const styles = {
  default: 'bg-stone-100 text-stone-600',
  success: 'bg-green-100 text-green-700',
  warning: 'bg-orange-100 text-orange-700',
  primary: 'bg-riverside-red text-white',
  confirmed: 'bg-green-100 text-green-700',
  danger: 'bg-red-100 text-red-700',
};

const Badge = ({ children, type = 'default', className = '' }) => (
  <span className={`px-2.5 py-0.5 rounded-full text-[10px] font-bold tracking-wide uppercase inline-flex items-center ${styles[type] || styles.default} ${className}`}>
    {children}
  </span>
);

export default Badge;
